import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useRequireAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
const Layout = () => {
    useRequireAuth(); // Proteger todas as rotas do layout
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (_jsxs("div", { className: "flex h-screen bg-gray-100", children: [_jsx(Sidebar, { isOpen: sidebarOpen, onToggle: toggleSidebar }), _jsxs("div", { className: "flex-1 flex flex-col overflow-hidden", children: [_jsx(Header, { onSidebarToggle: toggleSidebar }), _jsx("main", { className: "flex-1 overflow-auto bg-gray-50", children: _jsx(Outlet, {}) })] })] }));
};
export default Layout;
